import React, { useEffect, useState } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { Link, useHistory } from 'react-router-dom';
import PrePlannedEntry from './PrePlannedEntry';
import { ApiService } from '../api/ApiService';
import { PreplannedLoad } from '../api/model/PreplannedLoad';
import PreplannedLoadsFirstIn from '../components/walkthrough/individualPage/PreplannedLoadsFirstIn';
import { ChevronRight } from '../components/icons';
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';
import { useLogPageVisit } from '../utils/logPageVisit';

const moment = require('moment');

function formatJulianDate(value: number): string {
  const raw = String(value);
  const year = Number(raw.slice(0, 4));
  const dayOfYear = Number(raw.slice(4));
  return moment([year, 0, 1])
    .add(dayOfYear - 1, 'days')
    .format('M/D/YYYY');
}

const PrePlanned: React.FC = () => {
  useLogPageVisit('LP Pre Planned', 'User viewed the Pre Planned page');
  const history = useHistory();
  const { onSheet, onIonScroll } = useTransparentHeaderContrast();
  const [loads, setLoads] = useState<PreplannedLoad[]>([]);
  const [showNoLoads, setShowNoLoads] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      setTimeout(() => setMounted(true), 30);
    });
    return () => cancelAnimationFrame(id);
  }, []);

  useEffect(() => {
    getLoads();
  }, []);

  function getLoads() {
    setLoading(true);
    ApiService.getPreplannedLoads('prePlanned')
      .then(it => {
        const tempLoad = (it || []).map(load => ({
          ...load,
          deliveryStartDate: formatJulianDate(Number(load.deliveryStartDate)) as any,
          deliveryEndDate: formatJulianDate(Number(load.deliveryEndDate)) as any,
          pickupStartDate: formatJulianDate(Number(load.pickupStartDate)) as any,
          pickupEndDate: formatJulianDate(Number(load.pickupEndDate)) as any,
        }));
        setShowNoLoads(tempLoad.length === 0);
        setLoads(tempLoad);
      })
      .catch(() => {
        setShowNoLoads(true);
        setLoads([]);
      })
      .finally(() => setLoading(false));
  }

  const goBack = () => {
    if (history.length > 1) history.goBack();
    else history.replace('/Home');
  };

  return (
    <IonPage>
      <LoadDetailHeader title="Preplanned" onBack={goBack} onSheet={onSheet} />

      <IonContent
        fullscreen
        className="design-a-content"
        scrollEvents={true}
        onIonScroll={onIonScroll}
      >
        <PreplannedLoadsFirstIn>
          <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
            <div className="home-hero preplan-hero">
              <div className="preplan-hero__eyebrow">Upcoming assignments</div>
              <div className="preplan-hero__title home-display">Preplanned</div>
              <div className="preplan-hero__meta">
                {loading
                  ? 'Loading…'
                  : showNoLoads
                    ? 'No loads assigned yet'
                    : `${loads.length} load${loads.length === 1 ? '' : 's'} ready`}
              </div>
            </div>

            <div className="home-sheet preplan-sheet">
              {loads.map((load, index) => (
                <PrePlannedEntry key={`${load.orderNumber}-${index}`} load={load} />
              ))}

              {showNoLoads ? (
                <div className="preplan-empty">
                  <div className="preplan-empty__title home-display">Plan your loads</div>
                  <p className="preplan-empty__body">
                    Let’s get you another load. Contact dispatch from Help to get back on the road.
                  </p>
                  <Link to="/Support" className="preplan-empty__cta">
                    <span>Help</span>
                    <ChevronRight color="#ffffff" />
                  </Link>
                </div>
              ) : null}
            </div>
          </div>
        </PreplannedLoadsFirstIn>
      </IonContent>
    </IonPage>
  );
};

export default PrePlanned;
